export const VEHICLE_NAME_MAX_LENGTH = 25;
/** The most vehicles a parking authorizes to park on it at once; the backend refuses one more. */
export const PARKING_VEHICLE_LIMIT = 50;
/** The most vehicles a reservation holds at once; the backend refuses one more. */
export const RESERVATION_VEHICLE_LIMIT = 3;
